const base = {
  OIDC_AUTHORITY: "https://external-sso.ppd.wiley.com/auth/realms/wiley",
  OIDC_REDIRECT_URI: "/signin-oidc",
  OIDC_REFRESH_URI: "/refreshLogin",
  DOMAIN: "qap.wiley.host",
  OIDC_CLIENT_ID: "bcf56996-2033-4fc4-89dd-0fcaea2f4c5f",
  OIDC_CLIENT_SECRET: "c551ef18-f1b0-466e-8b13-acf00b251064",
  ALM_BASE_URL: "https://account.ppd.wiley.com",
  QAP_API_URL: "https://dev.qap.wiley.host/dev",
  BYPASS_OIDC: false,
  ENVIRONMENT: 'DEV',
  EQAT_REDIRECTION_URL: 'eqat://https@qap-qa.wiley.com',
  EQAT_LAUNCH_URL: 'eqat://https@dev.qap.wiley.host/dev',
  // AWS AppConfig settings
  APP_CONFIG_ENABLED: true,
  APP_CONFIG_ENDPOINT: '/app-config/feature-flags',
  APP_CONFIG_POLL_INTERVAL: 300000, // 5 minutes in milliseconds
};

export default base;
